import React from 'react'
import PropTypes from 'prop-types'
import { defaultTo, find, map, pipe, prop, propEq } from 'ramda'
import { withTheme } from 'styled-components'
import { Area, AreaChart, Tooltip, XAxis } from 'recharts'
import { getHoursData, chartTooltipProps } from '../helpers'
import Card from './Card'
import CardTitle from './CardTitle'
import CardValue from './CardValue'
import ChartWrap from './ChartWrap'
import Comparsion from './Comparsion'

const DivisionCard = props => {
  const { theme, filter, data, compareData } = props

  const division = prop('division', data)
  const dates = prop('dates', data)
  const cumulativeInCounts = prop('cumulativeInCounts', data)

  const compareDates = prop('dates', compareData) || []
  const compareCumulativeInCounts = prop('cumulativeInCounts', compareData)

  const formedHoursArray = getHoursData(dates)
  const formedData = map(item => {
    const comparesHourCount = pipe(
      find(propEq('hour', item.hour)),
      prop('count'),
      defaultTo(0)
    )(compareDates)
    return {
      ...item,
      compareCount: comparesHourCount
    }
  }, formedHoursArray)

  return (
    <Card>
      <CardTitle>{division}</CardTitle>
      <CardValue>Total: {cumulativeInCounts}</CardValue>

      <Comparsion
        filter={filter}
        totalInCount={cumulativeInCounts}
        totalCompareInCount={compareCumulativeInCounts}
      />

      <ChartWrap>
        <AreaChart
          data={formedData}
          width={550}
          height={150}
        >
          <XAxis dataKey="hour" />
          <Tooltip {...chartTooltipProps} />

          <Area
            type="monotone"
            dataKey="count"
            stroke={theme.palette.greenColor}
            fill={theme.palette.greenColor}
          />
          <Area
            type="monotone"
            dataKey="compareCount"
            stroke={theme.palette.primaryColor}
            fill={theme.palette.primaryColor}
          />
        </AreaChart>
      </ChartWrap>
    </Card>
  )
}

DivisionCard.propTypes = {
  theme: PropTypes.object,
  filter: PropTypes.object,
  data: PropTypes.object,
  compareData: PropTypes.object,
  filterDate: PropTypes.string
}

export default withTheme(DivisionCard)
